export default __webpack_public_path__ + "static/media/livenews1.fedfc23d.png";